import { Component, OnInit } from '@angular/core';
import {toDateTimeString} from '../../../providers/app-date-adapter';
import {PartnerWalletTransaction} from '../../../dto/partnerWalletTransaction';
import {Location} from '@angular/common';
import {PartnerWalletService} from '../../../partner-wallet.service';
import {ActivatedRoute} from '@angular/router';
import {PartnerWalletLoadModel} from '../../../models/partner-wallet-load-model';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {
  UploadLoadDocumentsDialogComponent
} from '../upload-load-documents-dialog/upload-load-documents-dialog.component';
import {ToastService} from 'angular-toastify';
import {FileHelper} from '../../../helpers/file-helper';
import {RoleService} from '../../../services/role.service';

@Component({
  selector: 'app-view-wallet-transaction',
  templateUrl: './view-wallet-transaction.component.html',
  styleUrls: ['./view-wallet-transaction.component.css']
})
export class ViewWalletTransactionComponent implements OnInit {
  private walletId: number;
  private txnId: number;

  constructor(
    private location: Location,
    private partnerWalletService: PartnerWalletService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private _toastService: ToastService,
    private roleService: RoleService,
  ) { }

  fieldsTransaction = [
    {columnDef: 'wallet', header: 'Wallet', cell: (row: PartnerWalletTransaction) => `${row.wallet.walletNumber}`},
    {columnDef: 'transactionData', header: 'Date', cell: (row: PartnerWalletTransaction) => `${toDateTimeString(row.transactionDate) || ''}`},
    {columnDef: 'amount', header: 'Amount', cell: (row: PartnerWalletTransaction) => `${row.amount.formatMoneyCcy(row.wallet.currencyCode)}`},
    {columnDef: 'description', header: 'Description', cell: (row: PartnerWalletTransaction) => `${row.comment || '(missing)'}`},

  ];
  public isLoading = false;
  public walletTransaction: PartnerWalletTransaction|null;
  fieldsLoad = [
    {columnDef: 'amount', header: 'Amount', cell: (row: PartnerWalletLoadModel) => `${row.amount.formatThousands() || ''}`},
    {columnDef: 'fee', header: 'Fee', cell: (row: PartnerWalletLoadModel) => `${row.loadFee.formatThousands() || ''}`},
    {columnDef: 'amountToLoad', header: 'Load Amount', cell: (row: PartnerWalletLoadModel) => `${row.amountToLoad.formatThousands() || ''}`},
    {columnDef: 'description', header: 'Description', cell: (row: PartnerWalletLoadModel) => `${row.description || '(missing)'}`},

  ];
  isBusy = false;

  ngOnInit(): void {
    const walletId = parseInt(this.route.snapshot.paramMap.get('id'));
    const txnId = parseInt(this.route.snapshot.paramMap.get('txnId'));

    this.walletId = walletId;
    this.txnId = txnId;

    this.loadWalletTransaction(walletId, txnId);
  }

  private loadWalletTransaction(walletId: number, txnId: number) {
    this.isLoading = true;
    this.partnerWalletService.getTransaction(walletId, txnId).subscribe(data => {
      this.isLoading = false;
      this.walletTransaction = data;

    });

  }

  uploadDocuments(loadId: number) {
    const dr = this.dialog.open(UploadLoadDocumentsDialogComponent, {
      maxWidth: 800,
    });

    dr.componentInstance.upload.subscribe((file: File) => {
        this.isBusy = true;

        this.partnerWalletService.uploadLoadFileDocuments(
          [file],
          loadId
        ).subscribe(res => {

          this.isBusy = false;


          this._toastService.success('File has been uploaded successfully');

          this.loadWalletTransaction(this.walletId, this.txnId);
        }, error => {
          this.isBusy = false;
          this._toastService.error(error.message);

        });
      }
    );
  }

  downloadDocument(loadDocId: number) {
    this.partnerWalletService.downloadPartnerLoadDocument( loadDocId ).subscribe(
      result => {
        FileHelper.saveFile( result );
      },
      err =>
        this._toastService.error(err.error.message || err.message || err.error || err)
    );
  }

  deleteDocument(id: number) {

    const that = this;
    const cptnId = id;

    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Delete document',
        text: 'Are you sure you want to delete this document?'
      },
      minWidth: 350,
    })
      .afterClosed()
      .subscribe(result => {
        if (result == 'ok') {
          that.partnerWalletService.deletePartnerLoadDocument(cptnId).subscribe(_ => {
            this.loadWalletTransaction(this.walletId, this.txnId);
          });

        }
      });

  }


  returnBack() {
    this.location.back();
  }

  isWallet() {
      return this.roleService.hasRoles(['wallet']);

  }
}
